import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase-config';
// Routes
import Home from './routes/Home';
import Login from './routes/Login';
import Signup from './routes/Signup';
import ForgetPassword from './routes/ForgetPassword';
import Profile from './routes/Profile';
import EditProfile from './routes/EditProfile';
import Courses from './routes/Courses';
import Course from './routes/Course';
import Enroll from './routes/Enroll';
import About from './routes/About';
import Contact from './routes/Contact';
// Components
import Preloader from './components/Preloader';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
// CSS
import './assets/css/form.css';

function App() {
  const [user, setUser] = useState('loading');

  onAuthStateChanged(auth, (user) => {
    if(user){
      setUser(true)
    }
    else{
      setUser(null);
    }
  })

  return (
    <div className="App">
      <Preloader />
      <Router>
        <Navbar />
        <div className="page_container">
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/login" exact element={user === true? <Navigate to='/' /> : user === null? <Login /> : <></>} />
            <Route path="/signup" exact element={user === true? <Navigate to='/' /> : user === null? <Signup /> : <></>} />
            <Route path="/forget-password" exact element={<ForgetPassword />} />
            <Route path='/profile' exact element={user === true? <Profile /> : user === null? <Navigate to='/login' /> : <></>} />
            <Route path='/edit-profile' exact element={user === true? <EditProfile /> : user === null? <Navigate to='/login' /> : <></>} />
            <Route path="/courses" exact element={<Courses />} />
            <Route path="/course/:courseId" exact element={<Course />} />
            <Route path="/enroll/:courseId" exact element={user === true? <Enroll /> : user === null? <Navigate to='/login' /> : <></>} />
            <Route path="/about" exact element={<About />} />
             <Route path="/contact" exact element={<Contact />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </div>
  );
}

export default App;
